// Мини-кейсы: реальные результаты продвижения (данные перенесены из src/js/components/horizontal-animation.js)
import au from '../../assets/svg/countries/AU.svg'
import br from '../../assets/svg/countries/BR.svg'
import by from '../../assets/svg/countries/BY.svg'
import ca from '../../assets/svg/countries/CA.svg'
import fr from '../../assets/svg/countries/FR.svg'
import gb from '../../assets/svg/countries/GB.svg'
import gr from '../../assets/svg/countries/GR.svg'
import il from '../../assets/svg/countries/IL.svg'
import kz from '../../assets/svg/countries/KZ.svg'
import mx from '../../assets/svg/countries/MX.svg'
import nl from '../../assets/svg/countries/NL.svg'
import rf from '../../assets/svg/countries/RF.svg'
import us from '../../assets/svg/countries/US.svg'

export const FLAGS = { au, br, by, ca, fr, gb, gr, il, kz, mx, nl, rf, us }

// [запрос, метрика, значение, позиция до, позиция после, страна, категория]
export const CASES = [
  ["авиабилеты", 'SAP', 64, 11, 3, 'rf', 'tickets'],
  ["билеты на самолет", 'SAP', 49, 7, 1, 'by', 'tickets'],
  ["дешевые авиабилеты", 'SAP', 30, 6, 1, 'rf', 'tickets'],
  ["поиск авиабилетов", 'SAP', 5, 10, 1, 'kz', 'tickets'],
  ["авиабилеты купить", 'SAP', 5, 21, 1, 'kz', 'tickets'],
  ["авиа билеты", 'SAP', 36, 18, 2, 'rf', 'tickets'],
  ["билет на самолет", 'SAP', 19, 13, 5, 'rf', 'tickets'],
  ["купить билет", 'SAP', 5, 16, 1, 'rf', 'tickets'],
  ["авиабилеты дешево", 'SAP', 25, 19, 3, 'rf', 'tickets'],
  ["знакомства", 'SAP', 76, 57, 4, 'rf', 'contact'],
  ["сайт знакомств", 'SAP', 66, 31, 3, 'rf', 'contact'],
  ["знакомства бесплатно", 'SAP', 61, 24, 5, 'rf', 'contact'],
  ["чат знакомства", 'SAP', 42, 13, 3, 'rf', 'contact'],
  ["знакомства рядом", 'SAP', 39, 12, 2, 'rf', 'contact'],
  ["отношения", 'SAP', 29, 20, 1, 'rf', 'contact'],
  ["любовь", 'SAP', 47, 91, 6, 'rf', 'contact'],
  ["сайт для знакомств", 'SAP', 28, 38, 1, 'rf', 'contact'],
  ["чат знакомств", 'SAP', 37, 12, 2, 'rf', 'contact'],
  ["dating", 'SAP', 35, 32, 4, 'rf', 'contact'],
  ["доставка еды", 'SAP', 64, 11, 2, 'rf', 'food'],
  ["продукты", 'SAP', 49, 6, 1, 'rf', 'food'],
  ["заказ продуктов", 'SAP', 49, 5, 2, 'rf', 'food'],
  ["продукты с доставкой", 'SAP', 5, 46, 1, 'rf', 'food'],
  ["заказ еды", 'SAP', 40, 22, 3, 'rf', 'food'],
  ["доставка", 'SAP', 58, 15, 2, 'rf', 'food'],
  ["продукты на дом", 'SAP', 45, 6, 2, 'rf', 'food'],
  ["магазин продуктов", 'SAP', 15, 12, 1, 'rf', 'food'],
  ["וולט", 'SAP', 74, 8, 1, 'il', 'food'],
  ["food", 'SAP', 41, 11, 2, 'il', 'food'],
  ["развивашки", 'SAP', 16, 51, 1, 'rf', 'games'],
  ["детская игра", 'SAP', 59, 23, 2, 'rf', 'games'],
  ["игры 3+", 'SAP', 50, 120, 2, 'rf', 'games'],
  ["головоломки для детей", 'SAP', 33, 12, 1, 'rf', 'games'],
  ["kids games", 'SAP', 60, 14, 3, 'ca', 'games'],
  ["jogos infantis gratis", 'SAP', 53, 116, 3, 'br', 'games'],
  ["jeux de fille", 'SAP', 56, 34, 2, 'fr', 'games'],
  ["игры для маленьких", 'SAP', 14, 112, 1, 'rf', 'games'],
  ["for kids", 'SAP', 26, 45, 3, 'us', 'games'],
  ["game for kids free", 'SAP', 26, 121, 1, 'us', 'games'],
  ["calorie tracker", 'SAP', 62, 53, 3, 'us', 'slim'],
  ["food tracker", 'SAP', 55, 12, 2, 'us', 'slim'],
  ["calorie", 'SAP', 43, 67, 2, 'us', 'slim'],
  ["похудение", 'SAP', 51, 9, 3, 'rf', 'slim'],
  ["диета", 'SAP', 39, 11, 2, 'rf', 'slim'],
  ["калории", 'SAP', 46, 88, 5, 'rf', 'slim'],
  ["подсчет калорий", 'SAP', 37, 71, 1, 'rf', 'slim'],
  ["кбжу", 'SAP', 34, 12, 1, 'rf', 'slim'],
  ["счетчик калорий", 'SAP', 64, 23, 4, 'rf', 'slim'],
  ["фитнес для похудения", 'SAP', 5, 52, 1, 'rf', 'slim'],
  ["editor de cara", 'SAP', 24, 24, 2, 'mx', 'photo'],
  ["filtro", 'SAP', 23, 103, 2, 'mx', 'photo'],
  ["hintergrund bearbeiten", 'SAP', 32, 67, 5, 'gr', 'photo'],
  ["filtros", 'SAP', 20, 137, 9, 'br', 'photo'],
  ["ton filtros", 'SAP', 11, 15, 1, 'br', 'photo'],
  ["face editor free", 'SAP', 24, 68, 3, 'us', 'photo'],
  ["face retouch", 'SAP', 20, 80, 6, 'us', 'photo'],
  ["обработка фото", 'SAP', 58, 62, 5, 'rf', 'photo'],
  ["фильтры для фото", 'SAP', 49, 181, 3, 'rf', 'photo'],
  ["ретушь лица", 'SAP', 45, 38, 2, 'rf', 'photo'],
  ["coin identifier", 'SAP', 39, 44, 3, 'ca', 'utils'],
  ["reports", 'SAP', 44, 26, 1, 'gr', 'utils'],
  ["ежедневник", 'SAP', 48, 16, 2, 'rf', 'utils'],
  ["phone cleaner", 'SAP', 42, 154, 4, 'gb', 'utils'],
  ["convert to pdf", 'SAP', 53, 105, 2, 'ca', 'utils'],
  ["очистка телефона", 'SAP', 21, 207, 4, 'rf', 'utils'],
  ["сканер qr", 'SAP', 14, 67, 4, 'rf', 'utils'],
  ["очистка памяти", 'SAP', 46, 176, 2, 'rf', 'utils'],
  ["cleaner", 'SAP', 37, 191, 3, 'rf', 'utils'],
  ["виджеты", 'SAP', 59, 78, 1, 'rf', 'utils'],
  ["такси", 'SAP', 76, 35, 4, 'rf', 'business'],
  ["фриланс", 'SAP', 41, 23, 3, 'rf', 'business'],
  ["поиск работы", 'SAP', 36, 18, 2, 'rf', 'business'],
  ["удаленная работа", 'SAP', 30, 12, 2, 'rf', 'business'],
  ["поиск сотрудников", 'SAP', 5, 17, 3, 'rf', 'business'],
  ["грузоперевозки", 'SAP', 38, 78, 4, 'rf', 'business'],
  ["аналитика", 'SAP', 17, 139, 3, 'rf', 'business'],
  ["курьер", 'SAP', 45, 110, 2, 'rf', 'business'],
  ["курьерская доставка", 'SAP', 30, 118, 3, 'rf', 'business'],
  ["учет расходов", 'SAP', 33, 48, 1, 'rf', 'business'],
  ["ai song generator", 'SAP', 33, 14, 3, 'au', 'ai'],
  ["ai music generator", 'SAP', 37, 11, 3, 'ca', 'ai'],
  ["ai photo generator", 'SAP', 61, 147, 4, 'us', 'ai'],
  ["tattoo ai", 'SAP', 54, 97, 2, 'us', 'ai'],
  ["ai voice changer", 'SAP', 38, 67, 3, 'us', 'ai'],
  ["ии фото", 'SAP', 55, 186, 3, 'rf', 'ai'],
  ["нейросеть бесплатно", 'SAP', 49, 202, 4, 'rf', 'ai'],
  ["оживление фото", 'SAP', 27, 93, 2, 'rf', 'ai'],
  ["ии чат", 'SAP', 39, 57, 1, 'rf', 'ai'],
  ["нейросеть текст", 'SAP', 31, 253, 3, 'rf', 'ai'],
  ["отели", 'SAP', 56, 9, 2, 'rf', 'hotel'],
  ["отели и гостиницы", 'SAP', 52, 13, 1, 'rf', 'hotel'],
  ["бронирование отелей", 'SAP', 41, 25, 2, 'rf', 'hotel'],
  ["гостиницы", 'SAP', 35, 11, 2, 'rf', 'hotel'],
  ["гостиница", 'SAP', 29, 9, 1, 'rf', 'hotel'],
  ["горящие туры", 'SAP', 52, 15, 2, 'rf', 'hotel'],
  ["туры", 'SAP', 57, 14, 2, 'rf', 'hotel'],
  ["бронь отелей", 'SAP', 21, 24, 3, 'rf', 'hotel'],
  ["забронировать отель", 'SAP', 21, 36, 5, 'rf', 'hotel'],
  ["бронь гостиницы", 'SAP', 5, 68, 2, 'rf', 'hotel'],
  ["фитнес онлайн", 'SAP', 37, 12, 1, 'rf', 'workout'],
  ["упражнения для пресса", 'SAP', 18, 5, 1, 'rf', 'workout'],
  ["фитнес", 'SAP', 58, 10, 3, 'rf', 'workout'],
  ["тренировки для дома", 'SAP', 27, 14, 1, 'rf', 'workout'],
  ["домашние тренировки", 'SAP', 21, 22, 1, 'rf', 'workout'],
  ["фитнес дома", 'SAP', 25, 30, 2, 'rf', 'workout'],
  ["тренировка дома", 'SAP', 40, 19, 4, 'rf', 'workout'],
  ["тренировки", 'SAP', 51, 27, 5, 'rf', 'workout'],
  ["упражнения", 'SAP', 35, 24, 3, 'rf', 'workout'],
  ["тренировки в зале", 'SAP', 45, 11, 2, 'rf', 'workout'],
  ["игра в слова", 'SAP', 45, 13, 1, 'rf', 'other'],
  ["тв", 'SAP', 53, 27, 4, 'rf', 'other'],
  ["meditatie", 'SAP', 31, 14, 1, 'nl', 'other'],
  ["астрология", 'SAP', 29, 8, 2, 'rf', 'other'],
  ["horoscope", 'SAP', 49, 157, 6, 'us', 'other'],
  ["пазлы", 'SAP', 52, 17, 3, 'rf', 'other'],
  ["музыка", 'SAP', 76, 33, 5, 'rf', 'other'],
  ["трекер привычек", 'SAP', 55, 118, 3, 'rf', 'other'],
  ["daily planner", 'SAP', 44, 19, 1, 'us', 'other'],
  ["фильмы бесплатно", 'SAP', 43, 10, 2, 'rf', 'other'],
]
